<template lang="pug">
  div(
    :style="styles.base(showModal)"
  )
    div(
      @click="closeModal"
    )
      CloseIcon(
        :style="styles.closeIcon"
      )
    div(
      :style="styles.modal"
    )
      slot
</template>
<script>
import CloseIcon from 'vue-material-design-icons/Close';
import LibraryGrid from '../general/LibraryGrid';
import MediaCard from '../general/MediaCard';
import store from '../../store';
export default {
  name: 'modal',
  components: {
    CloseIcon,
    MediaCard,
    LibraryGrid
  },
  methods: {
    closeModal() {
      console.log('close this modal');
      this.showModal = false;
      store.commit('hideModals', true);
    }
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 300);
  },
  data() {
    return {
      showModal: false,
      styles: {
        base: showModal => ({
          position: 'fixed',
          zIndex: '99999',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background: 'rgba(0,0,0,0.75)',
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexFlow: 'column nowrap',
          justifyContent: 'center',
          transition: 'all 0.2s',
          opacity: showModal ? '1' : '0',
          pointerEvents: showModal ? 'auto' : 'none'
        }),
        modal: {
          background: '#fff',
          width: '50vw',
          height: 'auto',
          margin: '0 auto',
          borderRadius: '2px',
          overflowY: 'scroll',
          minHeight: '20vh',
          position: 'relative'
        },
        closeIcon: {
          position: 'fixed',
          top: '20px',
          right: '20px',
          fontSize: '2em',
          color: '#eee',
          cursor: 'pointer'
        }
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/general/Modal.vue